import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/system";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

import SharePointService from "../services/sharepoint.service";

import LenaIMG from "./../assets/lena_mueller.jpg";
import MonikaIMG from "./../assets/monika_rank.jpg";

export default function CustomerManager() {
  const currentUser = JSON.parse(localStorage.getItem("user-data"));

  const [managerName, setManagerName] = useState(null);

  useEffect(() => {
    const fetchCM = async () => {
      try {
        const result = await SharePointService.getCustomerManager(currentUser.email);
        setManagerName(result);
      } catch (e) {
        console.error(e);
        setManagerName(undefined);
      }
    };
    fetchCM();
  }, [currentUser?.email]);

  const MANAGERS = {
    "Monika Rank": {
      name: "Monika Rank",
      phone: "07941 6460 513",
      email: "monika.rank@weinberger-immobilien.de",
      img: MonikaIMG,
    },
    "Lena Müller": {
      name: "Lena Müller",
      phone: "07941 6460 514",
      email: "lena.mueller@weinberger-immobilien.de",
      img: LenaIMG,
    },
  };

  // Loading
  if (managerName === null) {
    return (
      <Paper elevation={1}>
        <Box pt={3} px={{ xs: 2, sm: 3 }} textAlign="left">
          <Typography variant="h6">Ich bin für Sie da</Typography>
        </Box>
        <Box py={3} px={{ xs: 2, sm: 3 }} textAlign="center">
          <CircularProgress />
        </Box>
      </Paper>
    );
  }

  const data = MANAGERS[managerName];

  // Fallback, falls kein Treffer
  if (!data) {
    return (
      <Paper elevation={1}>
        <Box p={{ xs: 2, sm: 3 }}>
          <Typography variant="h6" gutterBottom>Ich bin für Sie da</Typography>
          <Typography variant="body2">
            Aktuell konnte keine Kundenmanagerin zugeordnet werden. Bitte versuchen Sie es später erneut.
          </Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper elevation={1}>
      <Box px={{ xs: 2, sm: 3 }} py={{ xs: 2, sm: 3 }}>
        <Typography variant="h6" gutterBottom>Ich bin für Sie da</Typography>

        <Grid container spacing={2} alignItems="center">
          {/* Bild */}
          <Grid item xs={12} sm={4} md={3}>
            <Box
              component="img"
              src={data.img}
              alt={data.name}
              sx={{
                display: "block",
                mx: { xs: "auto", sm: 0 },
                width: { xs: 160, sm: "100%" },
                maxWidth: 200,
                height: "auto",
                borderRadius: 1,
              }}
            />
          </Grid>

          {/* Text */}
          <Grid item xs={12} sm={8} md={9} sx={{ textAlign: { xs: "center", sm: "left" } }}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ lineHeight: 1.3 }}>
              Kundenmanagerin<br />{data.name}
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              Tel: {data.phone}
            </Typography>
            <Button
              component="a"
              href={`mailto:${data.email}`}
              variant="text"
              sx={{ mt: 0.5, p: 0, minWidth: 0 }}
            >
              E-Mail schreiben
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
